<template>
  <div>
    <div class="race-schedule-list">
      <div class="race-schedule-item" :class=" hasPerms(item.authorityFlag) ? '' : 'no-permission'"
        v-for="(item, index) in list"
        :key="index"
        @click="scheduleCardTap(item)">
        <div class="race-schedule-item-bg"></div>
        <div class="race-schedule-item-h1">{{ item.scheduleName }}</div>
        <div class="race-schedule-item-h2">
          {{index === 0 ? 'Preliminary Competition' : index === 1 ? 'Division Finals' : index === 2 ? 'National Finals' : ''}}
        </div>
        <!-- <div class="race-schedule-item-h2">参赛人数 {{ item.numberOfParticipants }}</div> -->
        <!-- <div class="race-schedule-item-h2">晋级人数 {{ item.numberOfQualified }}</div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { hasPermission } from '@/permission/index.js'

export default {
  props: {
    list: {
      type: Array
    }
  },
  data () {
    return {

    }
  },
  methods: {
    // 赛程点击事件
    scheduleCardTap (item) {
      // console.log('e', item)
      if (!this.hasPerms(item.authorityFlag)) {
        return this.$message.warning('暂无操作权限')
      }
      if (item.showPop) {
        this.$emit('showNational')
        return
      }
      if (item.path) {
        this.$router.push(
          {
            path: item.path,
            query: {
              scheduleFlag: item.scheduleFlag
            }
          }
        )
      }
    },
    hasPerms: function (flag) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(flag) // & !this.disabled
    }
  }
}
</script>
